// extracted by mini-css-extract-plugin
export default {"stepsList":"VariablesSidebar_stepsList__ZrF5K","divider":"VariablesSidebar_divider__-Pww7","infoTip":"VariablesSidebar_infoTip__BcVmX"};